"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertsCardSchema = exports.alertSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../helpers/schemas");
exports.alertSchema = zod_1.z.object({
    id: zod_1.z.number(),
    account_name: zod_1.z.string(),
    test_id: zod_1.z.number(),
    alert: zod_1.z.string(),
    date: schemas_1.ApiDateTimeSchema,
});
exports.alertsCardSchema = zod_1.z.record(zod_1.z.string(), // account id
zod_1.z.record(zod_1.z.enum(['srm', 'sequential_testing']), zod_1.z.array(exports.alertSchema)));
//# sourceMappingURL=schemas.js.map